import { createSlice } from "@reduxjs/toolkit";

var urlPath = 'https://hinh.handsinheart.com/api/';

const initialState = {
  Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
  loginUrl:           urlPath + 'LoginController.php',
  HospitalsGetUrl:    urlPath + 'HospitalGet.php',
  HospitalsPostUrl:   urlPath + 'HospitalPost.php',
  PackagesGetUrl:     urlPath + 'PackageGet.php',
  PackagesPostUrl:    urlPath + 'PackagePost.php',
  PeopleGetUrl:       urlPath + 'PeopleGet.php',
  OrderGetUrl:        urlPath + 'OrderGet.php',
  OrderPostUrl:       urlPath + 'OrderPost.php',
  PeoplePostUrl:      urlPath + 'PeoplePost.php',

  // ── Photo Upload ──────────────────────────────────────────
  OrderPhotoGetUrl:   urlPath + 'OrderPhotoGet.php',
  OrderPhotoPostUrl:  urlPath + 'OrderPhotoPost.php',
  OrderPhotoProxyUrl: urlPath + 'photo.php',
};

export const getUrlSlice = createSlice({
  name: "globalurl",
  initialState,
  reducers: {},
});

export default getUrlSlice.reducer;